export const getAuthorizationHeader = (accessToken: string) => ({
  Authorization: `Bearer ${accessToken}`,
})
